import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation AssignCredit($sourceId: ID!, $destinationUserIds: [ID!]!, $amount: Int!, $message: String!, $budget: BudgetCategoryRequest) {
    assignCredit(sourceId: $sourceId, destinationUserIds: $destinationUserIds, amount: $amount, message: $message, budget: $budget) {
      uuid
      transferIds
      message
      metadata {
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`

export const assignCreditKey = getQueryNames(mutation)[0]

export default mutation
